import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import TargetCursor from "components/TargetCursor";
import GlobalScrollReveal from "components/GlobalScrollReveal";
import NotFound from "pages/NotFound";
import Header from "components/ui/Header";
import Homepage from './pages/homepage-enterprise-ai-consulting-hub';
import SecurityComplianceHub from './pages/security-compliance-hub';
import TechnologyStackInfrastructure from './pages/technology-stack-infrastructure';
import ClientSuccessStoriesPage from './pages/client-success-stories-quantified-results-gallery';
import ContactConsultationPage from './pages/contact-consultation-multi-tier-engagement';
import EnterpriseAISolutions from './pages/enterprise-ai-solutions-service-architecture';
// import ResourceIntelligenceCenter from './pages/resource-intelligence-center';
import AboutPage from './pages/about-ai-infrastructure-architects';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
          <TargetCursor targetSelector={"a, button, input, textarea, select, .cursor-target"} spinDuration={4} hideDefaultCursor={true} />
          <GlobalScrollReveal />
          <ScrollToTop />
          <Header />
          <RouterRoutes>
            {/* Define your route here */}
            <Route path="/" element={<Homepage />} />
            <Route path="/homepage-enterprise-ai-consulting-hub" element={<Homepage />} />
            <Route path="/security-compliance-hub" element={<SecurityComplianceHub />} />
            <Route path="/technology-stack-infrastructure" element={<TechnologyStackInfrastructure />} />
            <Route path="/client-success-stories-quantified-results-gallery" element={<ClientSuccessStoriesPage />} />
            <Route path="/contact-consultation-multi-tier-engagement" element={<ContactConsultationPage />} />
            <Route path="/enterprise-ai-solutions-service-architecture" element={<EnterpriseAISolutions />} />
            {/** Resources route removed per request */}
            <Route path="/about-ai-infrastructure-architects" element={<AboutPage />} />
            <Route path="*" element={<NotFound />} />
          </RouterRoutes>
          {/* Global footer moved to App.jsx to ensure consistent rendering */}
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
